export const getOrderCancellationDate = (order) => {
	const hasCancellationNumber = order?.orderDayCounter != null && order?.orderCanceledDayCounter != null
	if (!hasCancellationNumber) return null
	const canceledInShiftDate = order.status?.status === 'CANCELED' ? order.status.modifiedDate : null
	return order.canceledDate || canceledInShiftDate || null
}
